import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { reportCashReconciliationTypes } from "redux/reducers/Reports/reportCashReconciliation/types";

const { SET_REPORT_CASH_RECONCILIATION_FILTERS } = reportCashReconciliationTypes;

export const getReportCashReconciliationAction = ({ date, station }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/cash-reconciliation/report?date=${date}&station=${station.id}`;
    const fileName = `Reporte_Corte_Caja_${station.name}_${date}.pdf`;

    dispatch(startRequestComp('loadingReportCashReconciliation'));
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth,
    };
    try {
      const pdf = await axios(access);
      saveAs(pdf.data, fileName);
      dispatch(setSnackbar('PDF Descargado con éxito', "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportCashReconciliation'));
    }
  };
};

export const setReportCashReconciliationFilters = (key = "", value) => {
  return {
    type: SET_REPORT_CASH_RECONCILIATION_FILTERS,
    payload: { value, key },
  };
};
